import Header from './components/Header';
import Background from './components/Background';
import Links from './components/Links';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header/>
      <Background/>
      <Links/>
      <Footer/>
    </div>
  );
}

export default App;
